let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("16dy1")).then(() => parcelRequire('j4dgK'));